import menuItemsProps from '../interfaces/MenuItemProps';
// recebe um array com a lista de items baseado na categoria escolhida e retorna 
// apenas os nomes dos items como uma string para ser lido pelo textoToSpeech;
const getItemName = (itemsList: Array<menuItemsProps>) => {
  let itemsNameArray: Array<string> = [];
  if (itemsList.length) {
    itemsNameArray = itemsList.map(itemEl => `${itemEl.item_name}, ${itemEl.price} reais. `);
  };
  let itemsNameString: string = '';
  itemsNameArray.forEach(itemEl => itemsNameString += `${itemEl}, `);
  return itemsNameString;
};

type itemNameForChart = {
  itemName: string;
  itemPrice: number;
  quantity: number;
}

const getItemNameForChart = (itemsList: Array<itemNameForChart>) => {
  
  let itemsNameString: string = 'Você possui os seguintes itens no seu pedido: ';
  
  if (itemsList.length) {
    itemsList.forEach(itemEl => {
      if (itemEl.quantity > 0) {
        itemsNameString += `
        -${itemEl.itemName}; ${itemEl.quantity} ${itemEl.quantity > 1 ? 'unidades' : 'unidade'}; ${itemEl.itemPrice * itemEl.quantity} reais. `;
      };
    });
  };

  // if (itemsList.length) {
  //   itemsList.forEach(itemEl => itemsNameString += `
  //     -${itemEl.itemName}; ${itemEl.quantity} ${itemEl.quantity > 1 ? 'unidades' : 'unidade'}; ${itemEl.itemPrice * itemEl.quantity} reais. `
  //   );
  // };
    
  return itemsNameString;
};

const itemListToArray = (itemsList: Array<itemNameForChart>) => {
  
  let itemsStringArray: Array<string> = [];

  if (itemsList.length) {
    itemsList.forEach(itemEl => {
      itemsStringArray.push(`
          -${itemEl.itemName}; ${itemEl.quantity} ${itemEl.quantity > 1 ? 'unidades' : 'unidade'}; ${itemEl.itemPrice * itemEl.quantity} reais. `
        );
    });
  };
   return itemsStringArray;
}

export {getItemName, getItemNameForChart, itemListToArray};